import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Card, CardBody, Table, Button } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { toastError, toastSuccess } from "../../helpers/msg_helper"
import { loggedUser as refreshUser } from "../../store/auth/login/actions"
import { getModules, saveModules } from "../../services/developer"
import "../Tenancy/tenancy.css"
import "./developer.css"

/**
 * Developer · Modules — enable/disable top-level modules for this customer.
 * Disabling a module hides its menu node from the sidebar app-wide (takes effect
 * on next login / page refresh, since the menu is built server-side).
 */
const DeveloperModules = () => {
  document.title = "Modules | Everrise"
  const dispatch = useDispatch()
  const [rows, setRows] = useState([])
  const [saving, setSaving] = useState(false)

  const load = async () => {
    try {
      const r = await getModules()
      setRows(r?.data || [])
    } catch (e) {
      toastError(e?.message || "Failed to load modules")
    }
  }
  useEffect(() => {
    load()
  }, [])

  const toggle = key =>
    setRows(rs => rs.map(m => (m.key === key && !m.is_core ? { ...m, enabled: !m.enabled } : m)))

  const save = async () => {
    setSaving(true)
    try {
      const map = {}
      rows.forEach(m => {
        if (!m.is_core) map[m.key] = !!m.enabled
      })
      const r = await saveModules(map)
      setRows(r?.data || rows)
      // Rebuild the sidebar live (server re-derives smenu without disabled modules).
      dispatch(refreshUser())
      toastSuccess("Modules updated")
    } catch (e) {
      toastError(e?.message || "Save failed")
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="page-content tnt-scope">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <Breadcrumbs
            title="Developer"
            breadcrumbObject={[
              { title: "Developer", link: "/developer" },
              { title: "Modules", link: "#" },
            ]}
          />
          <Button color="primary" size="sm" onClick={save} disabled={saving}>
            {saving ? "Saving…" : "Save changes"}
          </Button>
        </div>
        <Card className="me-2 px-2 pb-2 main-dashboard-bg">
          <CardBody>
            <Table responsive borderless className="align-middle tnt-table">
              <thead>
                <tr>
                  <th>Module</th>
                  <th>Key</th>
                  <th className="text-end">Enabled</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(m => (
                  <tr key={m.key}>
                    <td>{m.label}</td>
                    <td className="text-muted">{m.key}</td>
                    <td className="text-end">
                      {m.is_core ? (
                        <span className="badge bg-light text-muted">Always on</span>
                      ) : (
                        <div className="form-check form-switch d-inline-block">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            role="switch"
                            checked={!!m.enabled}
                            onChange={() => toggle(m.key)}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
                {!rows.length && (
                  <tr>
                    <td colSpan="3" className="text-center text-muted">
                      No modules
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default DeveloperModules
